import React from "react";
import { MdLocationOn, MdClose } from "react-icons/md";
import { WiDaySunny, WiCloudy, WiTime3 } from "react-icons/wi";

const LeftPanel = ({
    glass,
    showLeftPanel,
    setShowLeftPanel,
    locationTitle,
    center,
    forecastData,
    place,
    addressChips,
    selectedLabel,
    setSelectedLabel,
    tab,
    setTab,
}) => {
    if (!showLeftPanel) return null;
    return (
        <div className={`absolute top-1 left-1 p-2 rounded-2xl ${glass} text-white max-w-[280px] z-[10000] transition-all duration-300 hover:shadow-3xl`}>
            <div className="mb-2">
                <div className="flex items-center justify-between gap-1.5 text-[10px] opacity-80 mb-0.5">
                    <div className="flex items-center gap-1.5">
                        <MdLocationOn className="text-xs" />
                        <span>Weather Forecast</span>
                    </div>
                    <button
                        onClick={() => setShowLeftPanel(false)}
                        className="p-1 rounded hover:bg-white/20 transition-all duration-200"
                        title="Hide panel"
                    >
                        <MdClose className="text-sm" />
                    </button>
                </div>
                <div className="text-sm md:text-base font-bold bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
                    {locationTitle}
                </div>
            </div>
            <div className="space-y-1 mb-2">
                <div className="flex items-center gap-1.5 text-[10px] opacity-90 bg-black/20 px-1.5 py-1 rounded-lg">
                    <MdLocationOn className="text-green-400 text-xs" />
                    <span className="font-mono">{center[0].toFixed(4)}°N, {center[1].toFixed(4)}°E</span>
                </div>
                {forecastData?.elevation && (
                    <div className="text-[9px] opacity-75 px-2">
                        Elevation: {forecastData.elevation}m | {forecastData.timezone_abbreviation || forecastData.timezone}
                    </div>
                )}
                {place?.address && (
                    <div className="text-[9px] opacity-75 px-2 space-y-0.5">
                        {place.address.county && <div>County: {place.address.county}</div>}
                        {place.address.state_district && <div>District: {place.address.state_district}</div>}
                        {place.address.country_code && <div>Country Code: {place.address.country_code.toUpperCase()}</div>}
                    </div>
                )}
            </div>
            {addressChips.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mb-2">
                    {addressChips.map((c) => (
                        <button
                            key={c}
                            onClick={() => setSelectedLabel(c)}
                            className={`px-2 py-1 rounded-full text-[10px] font-medium border border-white/40 hover:bg-white/20 transition-all duration-200 transform hover:scale-105 ${selectedLabel === c ? "bg-white/30 shadow-lg" : "bg-white/10"}`}
                        >
                            {c}
                        </button>
                    ))}
                    {selectedLabel && (
                        <button
                            onClick={() => setSelectedLabel(null)}
                            className="px-2 py-1 rounded-full text-[10px] font-medium border border-red-400/40 bg-red-500/20 hover:bg-red-500/30 transition-all duration-200"
                        >
                            ✕
                        </button>
                    )}
                </div>
            )}
            <div className="flex gap-1">
                {[
                    { id: "current", icon: <WiDaySunny className="text-base" /> },
                    { id: "forecast", icon: <WiCloudy className="text-base" /> },
                    { id: "past", icon: <WiTime3 className="text-base" /> }
                ].map((t) => (
                    <button
                        key={t.id}
                        onClick={() => setTab(t.id)}
                        className={`flex items-center gap-1 px-2 py-1 rounded-lg text-[11px] capitalize font-semibold border border-white/30 hover:bg-white/20 transition-all duration-200 ${tab === t.id ? "bg-gradient-to-r from-blue-500/40 to-purple-500/40 shadow-lg" : "bg-white/10"}`}
                    >
                        {t.icon}
                        {t.id}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default LeftPanel;


